'use strict';

wbApp.directive('wbFlagCombo', ['$timeout', '$translate', 'leadSvc',
    function ($timeout, $translate, leadSvc) {
        function formatResult(model) {
            return "<i class='fa fa-flag' style='color:" + leadSvc.markerIdToColor(model.id) + "' aria-hidden='true'></i>&nbsp;&nbsp;" + $translate.instant(model.text);
        }

        function formatSelection(model) {
            return "<i class='fa fa-flag' style='color:" + leadSvc.markerIdToColor(model.id) + "' aria-hidden='true'></i>&nbsp;&nbsp;" + $translate.instant(model.text);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {

                    $(elm).select2({
                        placeholder: $translate.instant('TXT_LBL_FLAG'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        id: function (model) { return model.id; },
                        data: [
                            { id: 0, text: 'TXT_FLAG_RED' },
                            { id: 1, text: 'TXT_FLAG_ORANGE' },
                            { id: 2, text: 'TXT_FLAG_YELLOW' },
                            { id: 3, text: 'TXT_FLAG_GREEN' },
                            { id: 4, text: 'TXT_FLAG_BLUE' },
                            { id: 5, text: 'TXT_FLAG_PURPLE' },
                            { id: 6, text: 'TXT_FLAG_GRAY' },
                        ]                            
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (String.prototype.isNullOrWhitespace(viewValue)) {
                            return null;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!typeof value === 'undefined' || value === null) {
                            return value;
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    controller.$render();
                }, 1);
            }
        }
    }]);